/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcAssetsClearingV1MoneyMarketInternalStatsEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ASSETS_CLEARING_V1_MONEY_MARKET_INTERNAL_STATS_EVENT_ENTITY_NAME = 'ixc.assets.clearing.v1.MoneyMarketInternalStatsEvent';
export const ixcAssetsClearingV1MoneyMarketInternalStatsEventEntity = new schema.Entity<IxcAssetsClearingV1MoneyMarketInternalStatsEvent>(IXC_ASSETS_CLEARING_V1_MONEY_MARKET_INTERNAL_STATS_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcAssetsClearingV1MoneyMarketInternalStatsEvent) => `${entity.metadata?.eventId}` });

